import React from "react"
import SectionHeader from "../../molecules/SectionHeader"
import Title from "../../atoms/Title"
import CTA from "../../atoms/CTA"
import "./styles.scss"

const JobOffers = ({ title, offers, subtitle }) => {
  return (
    <section className="section section--jobOffers">
      <div className="wrapper--text">
        <SectionHeader
          attributes={{
            "data-sal": "slide-up",
            "data-sal-duration": "1000",
            "data-sal-easing": "ease",
          }}
          type="h2"
          subtitle={subtitle}
        >
          {title}
        </SectionHeader>
        <div className="offers">
          {offers.map(({ node: offer }, index) => {
            return (
              <div key={index} className="offer">
                <Title type="h3" className="offer__title">
                  {offer.Title}
                </Title>
                <div className="offer__content-wrapper">
                  <div className="offer__infos">
                    <div className="offer__info">
                      <span>MONTHLY SALARY</span>
                      <span>{offer.Salary}</span>
                    </div>
                    <div className="offer__info">
                      <span>LOCATION</span>
                      <span>{offer.location}</span>
                    </div>
                  </div>
                  <CTA
                    className="btn--bordered offer__btn"
                    to={`/careers/${offer.Title.toLowerCase()
                      .replace(/[^a-zA-Z ]/g, "")
                      .split(" ")
                      .join("-")}`}
                  >
                    Read more
                  </CTA>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default JobOffers
